import script from "./CompToogle.vue?vue&type=script&setup=true&lang=js"
export * from "./CompToogle.vue?vue&type=script&setup=true&lang=js"

import "./CompToogle.vue?vue&type=style&index=0&id=13c23425&lang=css"

const __exports__ = script;

export default __exports__